import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  name: 'Marcelo G.',
  location: 'Buenos Aires',
  text: 'Diagnostiqué yo solo por qué saltaba el diferencial. Eran 3 años pagando electricistas para lo mismo.',
  color: 'bg-electric'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Córdoba',
  text: 'Instalé el circuito del aire yo sola. Me ahorré $120.000 en un solo trabajo.',
  color: 'bg-energy'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Rosario',
  text: 'Resolví un diferencial que saltaba a las 3 AM en 4 minutos. Sin pánico. Sin pagar nada.',
  color: 'bg-gold'
}];
export function Testimonials() {
  return <section className="py-12 border-y border-petroleum bg-graphite/50" data-id="element-286">
      <div className="container mx-auto px-4" data-id="element-287">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-288">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-petroleum border border-electric/10 rounded-xl p-6 hover:border-electric/30 transition-colors" data-id="element-289">
              <div className="flex items-center gap-4 mb-4" data-id="element-290">
                <div className={`w-12 h-12 rounded-full ${t.color} flex items-center justify-center text-graphite font-bold text-lg`} data-id="element-291">
                  {t.initials}
                </div>
                <div data-id="element-292">
                  <div className="flex gap-1 mb-1" data-id="element-293">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-gold fill-gold" data-id="element-294" />)}
                  </div>
                  <div className="text-sm text-textsecondary" data-id="element-295">
                    <span className="text-white font-medium" data-id="element-296">{t.name}</span> •{' '}
                    {t.location}
                  </div>
                </div>
              </div>
              <p className="text-textsecondary italic" data-id="element-297">"{t.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}